import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { AnalyticsService } from '../../../@core/utils';
import { LayoutService } from '../../../@core/utils';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { PeticionesHttpBackEndService } from '../../../@core/mock/peticiones-http-backend.service';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})

export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  dataUser: any;
  

  NombreUsuario: string;
  tag: any;
  token: string;


  userMenu = [/*{title: 'Pestaña social'},*/{ title: 'Cerrar sesión'}];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private analyticsService: AnalyticsService,
              private layoutService: LayoutService,
              private authService: NbAuthService,
              private _http: PeticionesHttpBackEndService,
              private router:Router) {
          
              this.authService.getToken()
                  .subscribe((token: NbAuthJWTToken) => {
              if (token.isValid()) {
                this.token = token.getValue();
              }
              });
              
  }

  ngOnInit() {
    let Resultado: any;
    this.authService.getToken()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          this._http.getUsuario().subscribe(
            result => {
              Resultado = result;
              if (Resultado.Code == 200){
                this.NombreUsuario = Resultado.Entidad._nombre;
                if(Resultado.Entidad._apellidos != undefined){
                  this.NombreUsuario += " "+ Resultado.Entidad._apellidos;
                }
              }
            }
          );
        }
    });

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(
        title => {
          if (title == "Cerrar sesión"){
            localStorage.removeItem("auth_app_token");
            this.router.navigate(['public/inicio']);
          }else if(title == "Pestaña social"){
            this.router.navigate(['private/pestania-social']);
          }
        }
      );
    
    
  }


  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }
}
